import { _js } from '@ifixit/utils/localize';
import { useCallback, useState } from 'react';

/**
 * Screen-reader feedback for a reorder made without pointer motion (a
 * keyboard nudge, or a Ctrl+Up/Down line move): the row jump is otherwise
 * silent to AT, unlike a pointer drag which at least gives sighted feedback.
 * Shared by useDragReorder (grip Arrow keys) and the line editor's Ctrl+Up/
 * Down move (StepEditor) so the wording can't drift between the two.
 *
 * Position and count are both 1-based/total, e.g. `announce(2, 3)` for "the
 * item is now 2nd of 3".
 */
export function useReorderAnnouncement() {
   const [announcement, setAnnouncement] = useState('');
   const announce = useCallback((position: number, count: number) => {
      setAnnouncement(_js('Moved to position %1 of %2', String(position), String(count)));
   }, []);
   return { announcement, announce };
}
